import React, { FC, useState, useRef, useEffect } from 'react';
import { Modal, Button } from 'antd';

type ConfirmationDialogProps = {
  show: boolean;
  bodyMessage: string;
  loading?: boolean;
  onHide: () => void;
  onConfirm: () => void;
};

const ConfirmationDialogAnt: FC<ConfirmationDialogProps> = ({ show, bodyMessage, loading, onHide, onConfirm }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      containerRef.current.focus();
    }
  }, [show]);

  return (
    <Modal
      title='Confirm'
      visible={show}
      onCancel={onHide}
      className='confirmationDialogAnt'
      footer={[
        <Button autoFocus={true} ref={containerRef} key='submit' loading={loading} onClick={onConfirm}>
          Ok
        </Button>,
        <Button key='back' onClick={onHide}>
          Cancel
        </Button>
      ]}
    >
      <p>{bodyMessage}</p>
    </Modal>
  );
};

export default ConfirmationDialogAnt;
